import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const defaultItems = [
  "Taller privado de 2,5 a 3 h solo para vuestro equipo",
  "Elegís temática: sushi, pasta fresca o mexicano",
  "Cocináis vosotros, guiados por nuestro equipo",
  "Degustación de lo cocinado (sushi y mexicano)",
  "Copa de cava de bienvenida",
  "Una bebida por persona durante el taller",
  "Delantal Muérdete para cocinar (os lo prestamos durante el taller)"
];

export default function PackageProduct({
  thumb_src,
  thumb_alt,
  title,
  price,
  position = "center",
  minimumSpots,
  items = defaultItems
}) {
  const [isHovered, setIsHovered] = useState(false);
  const featureItems = items && items.length > 0 ? items : defaultItems;

  return (
    <div className="col-12 col-md-6 col-lg-4 mb-4 d-flex align-items-stretch">
      <div
        className="card border-light w-100 shadow-xl"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          borderRadius: '16px',
          overflow: 'hidden',
          backgroundColor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          transform: isHovered ? 'translateY(-6px)' : 'translateY(0)',
          boxShadow: isHovered
            ? '0 20px 35px rgba(0, 0, 0, 0.12)'
            : '0 10px 25px rgba(0, 0, 0, 0.06)',
          border: '1px solid rgba(0, 0, 0, 0.06)',
        }}
      >
        <Link
          to={`https://api.whatsapp.com/send/?phone=%2B34673553301&text=Quiero+saber+mas+sobre+el+pack+de+${minimumSpots}+personas`}
          target="_blank"
          className="text-decoration-none text-dark d-flex flex-column h-100"
          style={{ textDecoration: 'none', color: 'inherit', height: '100%', flex: 1 }}
        >
          <div className="card-body d-flex flex-column h-100 p-4 text-center">
            {/* Cabecera: Número y PERSONAS */}
            <div>
              <h2 className="font-weight-bold text-dark mb-0" style={{ fontSize: '2.5rem', lineHeight: 1.1 }}>
                {minimumSpots}
              </h2>
              <h4 className="font-weight-bold text-xl text-dark mb-3" style={{ letterSpacing: '1px' }}>
                PERSONAS
              </h4>
            </div>

            {/* Icono centrado con dimensiones fijas */}
            <div className="d-flex justify-content-center align-items-center my-3" style={{ height: '70px' }}>
              <img
                src={thumb_src}
                alt={thumb_alt}
                style={{ width: '65px', height: '65px', maxHeight: '65px', objectFit: 'contain' }}
              />
            </div>

            {/* Lista de características estrictamente dentro de la tarjeta */}
            <div className="px-1 my-3 text-start flex-grow-1">
              <ul className="list-unstyled mb-0" style={{ paddingLeft: 0, margin: 0 }}>
                {featureItems.map((item, idx) => (
                  <li
                    key={idx}
                    className="d-flex align-items-start mb-2 text-dark font-weight-normal"
                    style={{ fontSize: '0.88rem', lineHeight: '1.4' }}
                  >
                    <span className="me-2 font-weight-bold flex-shrink-0" style={{ color: '#25D366', fontSize: '1rem', lineHeight: '1.2' }}>
                      ✓
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Precio al pie de la tarjeta */}
            <div className="mt-auto pt-3 border-top text-center w-100">
              <h2 className="font-weight-bold text-dark mb-0" style={{ fontSize: '2rem' }}>
                {price} €
              </h2>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
